class Filter {
	constructor() {
		this.terms();
		this.search();
		this.filterToggle();
		this.sortby();
		this.mobileToggle();
	}

	mobileToggle(){
		if($(window).width() < 991){
			$('#files-page #mobile-filter').on('click', function(e){
				$('#files-page .filters').addClass('toggled');
			});

			$('#files-page .filters h3').on('click', function(e){
				$('#files-page .filters').removeClass('toggled');
			});
		}
	}

	search() {
		$('#search-files-form').on('submit', function(e){
			e.preventDefault();

			let searchparams = new URLSearchParams(window.location.search);
			searchparams.set('search-files', $('#search-files').val());
			
			let location = window.location.href.split("page")[0];
			location = location.split("?")[0];

			window.location.href = location + '?' + searchparams.toString();
		});
	}

	filterToggle() {
		$(document).ready(function(){
			if(localStorage.getItem('categories')){
				$('.filter-by-group-categories').addClass('show');
			}

			if(localStorage.getItem('types')){
				$('.filter-by-group-types').addClass('show');
			}
		});

		$('.filter-toggle-show-more').on('click', function(e){
			if($(this).parent().hasClass('show')){
				localStorage.removeItem($(this).attr('data-parent-toggler'));
				$(this).parent().removeClass('show')
			}else{
				localStorage.setItem($(this).attr('data-parent-toggler'), true);
				$(this).parent().addClass('show')
			}
		});
	}

	terms() {
    $('.filter-by-term').on('click', function(e){
			let searchparams = new URLSearchParams(window.location.search),
					termid = String($(this).data('termid')),
					type = $(this).data('type'),
					params = searchparams.has('filter-by-'+type) ? searchparams.get('filter-by-'+type) : '';

			// check params and make it an array if found
			params = params.length > 0 ? ((params.split(",")).filter(n => n)) : [];

			// add or remove from array
			if(params.includes(termid)){
				params.splice(params.indexOf(termid), 1);
			}else{
				params.push(termid);
			}

			// add to param or remove param
			if(params.length > 0 ){
				searchparams.set('filter-by-'+type, params.length > 0 ? params.join() : '');
			}else{
				searchparams.delete('filter-by-'+type);
			}

			let location = window.location.href.split("page")[0];
			location = location.split("?")[0];

      // update url
			window.location.href = location + '?' + searchparams.toString();
    });
  }

	sortby() {
		$('#sort-by > select').on('change', function(){
			let searchparams = new URLSearchParams(window.location.search);
			searchparams.set('sortby', this.value);
			
			let location = window.location.href.split("page")[0];
			location = location.split("?")[0];

			window.location.href = location + '?' + searchparams.toString();
		});
  }
}

export default Filter;
